const MARKDOWN_PATTERN =
  /(?:^#{1,6}\s|^\s*[-*+]\s|^\s*\d+\.\s|\*\*[^*]+\*\*|__[^_]+__|`[^`]+`|\[.+?\]\(.+?\)|^>\s)/m

/**
 * Detects whether a string likely contains markdown formatting.
 * Checks for headings, lists, bold, inline code, links, and blockquotes.
 */
export const containsMarkdown = (text: string): boolean => MARKDOWN_PATTERN.test(text)
